// extracted by mini-css-extract-plugin
export var callCard = "_m7-0";
export var callMessageButton = "_m7-1";
export var helpIcon = "_m7-3";
export var helpIconContainer = "_m7-4";
export var verticalDivider = "_m7-2";